import React from 'react'
import { Box, Button } from '@mui/material'
import EditIcon from '@mui/icons-material/Edit'
import { makeStyles } from '@material-ui/core/styles'
import ProviderImg from 'src/assets/Buy_Policy_Images/digitVector.svg'

const ThridPartyCheckoutTile = () => {
  const classes = useStyles()

  return (
    <Box>
      <Box className={classes.checkoutContainer}>
        <Box className={classes.checkoutSection}>
          <Box className={classes.editSection}>
            <Button>
              <EditIcon fontSize='medium' className={classes.editBtn} />
            </Button>
          </Box>

          <Box className={classes.logoSection}>
            <Box className={classes.logoContainer}>
              <img
                src={ProviderImg}
                width={'47px'}
                height={'16px'}
                alt='providerLogo'
              />
            </Box>

            <Box>
              <Box className={classes.providerName}>SBI</Box>
              <Box className={classes.insuranceType}>Third Party</Box>
            </Box>
          </Box>

          <Box className={classes.premiumSection}>
            <Box className={classes.premiumSectionHeading}>Premium details</Box>
            <Box className={classes.PriceDetailsContainerRow}>
              <Box className={classes.PriceDetailsContainerRowHeadingStyle}>
                Net Premium
              </Box>
              <Box className={classes.PriceDetailsContainerRowDataStyle}>
                ₹1,400
              </Box>
            </Box>
            <Box className={classes.PriceDetailsContainerRow}>
              <Box className={classes.PriceDetailsContainerRowHeadingStyle}>
                GST
              </Box>
              <Box className={classes.PriceDetailsContainerRowDataStyle}>
                ₹693
              </Box>
            </Box>
            <Box className={classes.premiumTotalSection}>
              <Box className={classes.premiumTotalSectionRow}>
                <Box className={classes.premiumTotalText}>Total</Box>
                <Box className={classes.premiumTotalPrice}>₹1,543</Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default ThridPartyCheckoutTile

const useStyles = makeStyles({
  checkoutContainer: {
    width: '187px',
    height: '193px',
    borderRadius: '10px',
    background: '#FFFFFF',
    boxShadow: '0px 4px 4px 0px #A3DDED',
  },
  checkoutSection: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    padding: 20,
    gap: 20,
  },
  logoSection: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'start',
    alignItems: 'center',
    gap: 10,
  },
  editSection: {
    right: 0,
    top: 4,
    position: 'absolute',
  },
  editBtn: {
    color: '#34C0E5',
  },

  premiumSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
  },
  PriceDetailsContainerRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  PriceDetailsContainerColumn: {
    display: 'flex',
    flexDirection: 'column',
  },
  PriceDetailsContainerRowHeadingStyle: {
    fontFamily: 'Roboto',
    fontSize: '11px',
    fontWeight: 400,
    lineHeight: '13px',
    letterSpacing: '0em',
    color: '#808080',
  },
  PriceDetailsContainerRowDataStyle: {
    fontFamily: 'Roboto',
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '15.23px',
    letterSpacing: '0em',
    color: '#000000',
  },
  premiumSectionHeading: {
    fontFamily: 'Roboto',
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '14.06px',
    letterSpacing: '0em',
    color: '#000000',
  },
  premiumTotalSection: {
    backgroundColor: '#ECECEC',
    borderRadius: '5px',
    height: '30px',
  },
  premiumTotalSectionRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: 7,
  },
  premiumTotalText: {
    fontFamily: 'Roboto',
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '14.06px',
    letterSpacing: '0em',
    color: '#000000',
  },
  premiumTotalPrice: {
    fontFamily: 'Roboto',
    fontSize: '13px',
    fontWeight: 600,
    lineHeight: '15.23px',
    letterSpacing: '0em',
    color: '#000000',
  },
  logoContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '67px',
    height: '47px',
    borderRadius: '10px',
    border: '1px solid #CEEFF7',
  },
  providerName: {
    fontFamily: 'Roboto',
    fontSize: '13px',
    fontWeight: 500,
    lineHeight: '15.23px',
    letterSpacing: '0em',
    color: '#34C0E5',
  },
  insuranceType: {
    fontFamily: 'Roboto',
    fontSize: '11px',
    fontWeight: 400,
    lineHeight: '12.89px',
    letterSpacing: '0em',
    color: '#8F8F8F',
  },
})
